import React, { Component } from 'react';
import { View, ActivityIndicator, Image, ImageProgress } from 'core';
import { imageProcessor } from 'utils';
import { SUCCESS, LOADING, IMAGE_SIZE, css, theme } from 'constants';

const styles = css({
  progress: {
    position: 'absolute'
  },
  bg: {
    backgroundColor: theme.gray_color_alpha(0.7)
  },
  container: { alignItems: 'center', justifyContent: 'center' }
});

export class Upload extends Component {
  state = {};
  componentDidUpdate(prevProps) {
    const { file } = this.props.current_msg;
    const prev_file = prevProps.current_msg.file;
    const prev_status = prev_file && prev_file.status;
    if (file && prev_status === LOADING && file.status === SUCCESS) {
      this.setState({ server_proccessing: true });
    }
  }

  render() {
    const { server_proccessing } = this.state;
    const { current_msg } = this.props;
    const { data, file } = current_msg;
    const { base64, width, height } = data;
    const style = imageProcessor.getDimensions(width / height, IMAGE_SIZE.MEDIUM);
    const blobURL = file && file.original_uri;
    return (
      <View style={[style, styles.container]}>
        {base64 ? <Image source={{ uri: blobURL || base64 }} style={style} /> : null}
        <View style={[style, styles.progress, styles.bg]} />
        {file ? <ImageProgress file={file} style={styles.progress} /> : <ActivityIndicator size="large" color="white" style={styles.progress} />}
        {server_proccessing ? <ActivityIndicator size="large" color="white" style={styles.progress} /> : null}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/upload.js